import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import moment from 'moment';
import FMPHeadline from '../../components/ui/FMPHeadline';
import Button from '@material-ui/core/Button';
import StationInvoicesContainer from '../../containers/accounting/StationInvoices';
import StationsContainer from '../../containers/Stations';

import { TabContainer } from '../../components/Tabs';
import FMPDatePicker from '../../components/pureForm/FMPDatePicker';
import FMPSectionHeader from '../../components/ui/FMPSectionHeader';
import FMPText from '../../components/pureForm/FMPText';

import { invoiceStatusClassNames } from '../accounting/general';
import invoiceIcon from '../../images/invoicePdf.svg';
import quickbooksLogo from '../../images/quickbooksLogo.svg';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormComponent from '../../components/FormComponent';
import DownloadIcon from '@material-ui/icons/CloudDownload';
import FMPStationMultiSelect from '../../components/pureForm/FMPStationMultiSelect';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import StationIcon from '@material-ui/icons/LocalGasStation';
import RestorePageIcon from '@material-ui/icons/RestorePage';
import FilterIcon from '@material-ui/icons/Filter';
//import { post } from '../../modules/utility';

import Popover from '@material-ui/core/Popover';

import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import CloseIcon from '@material-ui/icons/Close';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import Slide from '@material-ui/core/Slide';
import { green } from '@material-ui/core/colors';
import orange from '@material-ui/core/colors/orange';
import { getSharedStyles } from '../../themes';
import AuthUserContainer from '../../containers/AuthUser';
import SwipeableViews from 'react-swipeable-views';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import FMPStationRegionPicker from '../../components/pureForm/FMPStationRegionPicker';
import FMPStationOwnershipGroupPicker from '../../components/pureForm/FMPStationOwnershipGroupPicker';

const isLocalhost = Boolean(window.location.hostname === 'localhost');
const SlideUpTransition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

const styles = (theme) => {
	return {
		...invoiceStatusClassNames,
		...getSharedStyles(theme),
		bigButton: {
			borderRadius: '100px',
			padding: '18px 34px',
			fontSize: 16,
		},
		smallButton: {
			borderRadius: '100px',
			fontWeight: 200,
		},
		pickPlease: {
			background: '#F7F7F7',
			border: '1px solid #DDDDDD',
			padding: 20,
			color: '#666',
		},
		divider: {
			borderBottom: '1px dashed #dddddd',
			marginBottom: 25,
			marginTop: 25,
		},
		stats: {
			padding: '20px 10px 20px 10px',
			borderBottom: '1px solid #ddd',
			marginBottom: 10,
		},
		statGroup: {
			padding: '5px 5px 10px 5px',
			borderBottom: '1px solid #eee',
			marginBottom: 10,
		},
		available: {
			fontWeight: 900,
		},
		invoiceDocument: {
			position: 'absolute',
		},
		invoiceDocumentContainer: {
			position: 'relative',
			display: 'flex',
			alignItems: 'center',
		},
		invoiceIcon: {
			display: 'inline-block',
			width: 40,
			height: 48,
			backgroundImage: `url('${invoiceIcon}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			position: 'relative',
			flexShrink: 0,
			cursor: 'pointer',
		},
		quickbooksIcon: {
			display: 'inline-block',
			width: 40,
			height: 40,
			backgroundImage: `url('${quickbooksLogo}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			position: 'relative',
			flexShrink: 0,
			cursor: 'pointer',
		},
		table: {
			width: '100%',
			tableLayout: 'auto',
		},
		row: {
			cursor: 'pointer',
		},
		button: {
			verticalAlign: 'middle',
			padding: '8px 10px',
		},
		resultsHere: {
			padding: 30,
			backgroundColor: '#f1f1f1',
			color: '#777',
			borderRadius: 10,
		},
		runningSearch: {
			paddingLeft: 5,
			display: 'flex',
			alignItems: 'center',
			fontSize: 16,
			color: '#666',
		},
		dateRange: {
			marginRight: 10,
		},
		icon: {
			marginRight: 5,
		},
		linkedItem: {
			fontSize: 14,
			textDecoration: 'none',
			display: 'flex',
			alignItems: 'center',
		},
		openLink: {
			paddingLeft: 4,
			width: 14,
			height: 14,
		},
		diffError: {
			fontWeight: 900,
			color: '#FF500F',
		},
		contractSub: {
			paddingLeft: 10,
			fontSize: 14,
			color: '#666',
		},
		todo: {
			border: `1px solid #bbb`,
			color: '#666',
			padding: 5,
			fontStyle: 'italic',
		},
		addButton: {
			verticalAlign: 'middle',
			textDecoration: 'none',
			marginBottom: 10,
			borderRadius: 100,
		},
		fuelGroup: {
			marginBottom: 7,
		},
		savedSearchHelp: {
			padding: 10,
			color: '#444',
			backgroundColor: '#f7f7f7',
			border: '1px solid #eee',
			marginTop: 5,
			fontWeight: 200,
			marginBottom: 10,
		},
		saveNewSearchSection: {
			//borderTop : '1px solid #d7d7d7',
			marginTop: 20,
			paddingTop: 10,
		},
		noSavedSearches: {
			color: '#666',
			padding: 5,
			fontStyle: 'italic',
		},
		savedSearchContainer: {
			marginTop: 10,
			paddingTop: 10,
			borderBottom: '1px solid #d7d7d7',
			marginBottom: 10,
			paddingBottom: 5,
			display: 'flex',
			justifyContent: 'space-between',
		},
		addedOn: {
			fontSize: '85%',
			fontWeight: 200,
			color: '#666',
			paddingTop: 3,
		},
		snackbarSuccess: {
			backgroundColor: green[600],
		},
		snackbarIcon: {
			opacity: 0.9,
			marginRight: theme.spacing(1),
			fontSize: 20,
		},
		snackbarMessage: {
			display: 'flex',
			alignItems: 'center',
		},
		cancelled: {
			color: orange[500],
			fontWeight: 900,
		},
		popOverPaper: {
			textAlign: 'left',
			boxSizing: 'border-box',
			padding: 20,
		},
		commentsContainer: {
			padding: 7,
			display: 'inline-block',
			fontSize: '95%',
		},
		commentDateTime: {
			fontSize: '80%',
			color: '#666',
		},
		popover: {
			pointerEvents: 'none',
		},
	};
};

const LOCAL_ITEM_NAME = 'salesExportSaveSearches';

class SalesExport extends FormComponent {
	constructor(props) {
		super(props);

		let savedSearches = [];
		if (localStorage.getItem(LOCAL_ITEM_NAME)) {
			try {
				savedSearches = JSON.parse(localStorage.getItem(LOCAL_ITEM_NAME));
			} catch (e) {
				console.error('problems fetching saved searches from local storage', e);
			}
		}

		const dateRange = 'thisMonth';
		const { afterDate, beforeDate } = this.dateRangeToDates(dateRange);
		this.state = {
			formFieldError: {},
			deliveryType: 'all',
			dateRange,
			afterDate,
			beforeDate,
			searchResultRows: undefined,
			order: 'desc',
			orderBy: 'stationInvoiceId',
			isSearching: false,
			savedSearches,
			stationIds: [],
			commentPopoverAnchor: undefined,
			popoverComment: '',
			snackbarIsOpen: false,
			tabIndex: 0,
		};
	}

	componentDidMount() {
		//- Only used for updates
		const { stations, searchStations } = this.props;

		if (_.isEmpty(stations)) {
			searchStations();
		}
	}

	getApiParams = () => {
		const { accessToken } = this.props;

		const { afterDate, beforeDate, region, ownershipGroup } = this.state;

		const afterMoment = moment(afterDate);
		const beforeMoment = moment(beforeDate);

		const params = {
			accessToken,
			afterDate: afterMoment.format('YYYY-MM-DD'),
			beforeDate: beforeMoment.format('YYYY-MM-DD'),
			region,
			ownershipGroup,
		};

		['stationIds'].forEach((s) => {
			if (this.state[s]) {
				params[`${s}`] = this.state[s];
			}
		});
		return params;
	};

	/*
	submitSearch = () => {
		const { showErrors } = this.props;

		const formFieldError = {};
		_.values(this.requiredPathMap).forEach(({ path, label }) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});

		const { afterDate, beforeDate } = this.state;

		const afterMoment = moment(afterDate);
		const beforeMoment = moment(beforeDate);

		if (afterMoment.isAfter(beforeMoment)) {
			formFieldError.afterDate = `Before date can't be before after date. Time is not a circle man.`;
		}

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		this.setState({
			isSearching: true,
		});

		const params = this.getApiParams();
		post({
			method: 'masterSales.search',
			params,
			callback: (err, apiSearchResult) => {
				this.setState({ isSearching: false });
				if (err) {
					return showErrors(_.isArray(err) ? err : [err]);
				}

				this.formatSearchResults(apiSearchResult);
			},
		});
	};
	*/

	handleSnackbarClose = (_event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		this.setState({ snackbarIsOpen: false });
	};

	handleCommentPopoverOpen = (event, internalNote) => {
		this.setState({
			popoverComment: internalNote,
			commentPopoverAnchor: event.currentTarget,
		});
	};
	handleCommentPopoverClose = () => {
		this.setState({ commentPopoverAnchor: null });
	};

	handleTabChange = (_event, tabIndex) => {
		const newState = { tabIndex };
		if (tabIndex === 1) {
			newState.stationIds = undefined;
		} else {
			newState.region = undefined;
			newState.ownershipGroup = undefined;
		}
		this.setState(newState);
	};

	handleChangeTabIndex = (index) => {
		this.setState({ tabIndex: index });
	};

	render() {
		const { classes } = this.props;
		return (
			<Grid container spacing={2}>
				<Grid item md={8} xs={12}>
					{this.renderSearch()}
				</Grid>
				<Grid item md={4} xs={12}>
					{this.renderSaveSearches()}
				</Grid>

				<Snackbar
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'right',
					}}
					open={this.state.snackbarIsOpen}
					autoHideDuration={2000}
					onClose={this.handleSnackbarClose}
					TransitionComponent={SlideUpTransition}
				>
					<SnackbarContent
						className={classes.snackbarSuccess}
						aria-describedby="client-snackbar"
						message={
							<span id="client-snackbar" className={classes.snackbarMessage}>
								<CheckCircleIcon className={classes.snackbarIcon} />
								<strong>{this.state.snackbarMessage} </strong>
							</span>
						}
						action={[
							<IconButton
								key="close"
								aria-label="close"
								color="inherit"
								onClick={this.handleSnackbarClose}
							>
								<CloseIcon className={classes.icon} />
							</IconButton>,
						]}
					/>
				</Snackbar>

				<Popover
					id="comment-popover"
					className={classes.popover}
					classes={{ paper: classes.popOverPaper }}
					open={!!this.state.commentPopoverAnchor}
					anchorEl={this.state.commentPopoverAnchor}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}}
					onClose={this.state.handleCommentPopoverClose}
					disableRestoreFocus
				>
					<div className={classes.commentsContainer}>
						{!!this.state.popoverComment && <div>{this.state.popoverComment}</div>}
					</div>
				</Popover>
			</Grid>
		);
	}

	saveSearch() {
		const {
			savedSearches,
			savedName,
			stationIds,
			dateRange,
			afterDate,
			beforeDate,
			region,
			ownershipGroup,
			tabIndex,
		} = this.state;

		const { showErrors } = this.props;

		const formFieldError = {};
		if (!savedName) {
			formFieldError.savedName = `Do you like chaos?! If you don't name your search then you get chaos.`;
		}

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		const newSavedSearches = savedSearches.concat({
			name: savedName,
			dateCreated: moment().format('YYYY-MM-DD HH:mm'),
			savedState: {
				stationIds,
				dateRange,
				afterDate,
				beforeDate,
				region,
				ownershipGroup,
				tabIndex,
			},
		});
		this.setState(
			{
				savedSearches: newSavedSearches,
				snackbarMessage: 'Saved search for future use',
				snackbarIsOpen: true,
			},
			() => {
				localStorage.setItem(LOCAL_ITEM_NAME, JSON.stringify(newSavedSearches));
			}
		);
	}

	removeSavedSearch(index) {
		const { savedSearches } = this.state;
		const newSavedSearches = savedSearches.slice();
		newSavedSearches.splice(index, 1);
		this.setState({ savedSearches: newSavedSearches }, () => {
			localStorage.setItem(LOCAL_ITEM_NAME, JSON.stringify(newSavedSearches));
		});
	}

	restoreSavedSearch(index) {
		const { savedSearches } = this.state;
		const savedSearch = savedSearches[index];
		if (!savedSearch) {
			console.error('Saved search empty', savedSearches);
			return;
		}

		const { savedState } = savedSearch;

		if (savedState.dateRange) {
			if (savedState.dateRange !== 'custom') {
				const { afterDate, beforeDate } = this.dateRangeToDates(savedState.dateRange);
				if (afterDate) {
					savedState.afterDate = afterDate;
					savedState.beforeDate = beforeDate;
				}
			}
		}

		if (!savedState.tabIndex) {
			savedState.tabIndex = 0;
		}

		savedState.snackbarMessage = `Restored saved search options`;
		savedState.snackbarIsOpen = true;
		this.setState(savedState);
	}

	renderSaveSearches() {
		const { classes } = this.props;
		const { savedSearches } = this.state;
		return (
			<>
				<FMPHeadline label="My Saved Searches" />
				<Paper className={classes.paper}>
					<FMPSectionHeader label="My Saved Searches" isTop={true} />
					<div className={classes.savedSearchHelp}>
						<strong>How to use:</strong> First set the values for all the search fields you want to
						save on the left. Then pick a name for your saved search and hit add. This saved search
						will be available on future visits.
					</div>
					{_.isEmpty(savedSearches) && (
						<div className={classes.noSavedSearches}>No saved searches</div>
					)}

					{savedSearches.map((savedSearch, index) => {
						const { name, dateCreated } = savedSearch;
						return (
							<div className={classes.savedSearchContainer} key={name}>
								<div>
									<div>
										<strong>Name:</strong> {name}
									</div>
									<div className={classes.addedOn}>
										Date Created: {moment(dateCreated).format('MMM D, YYYY')}
									</div>
								</div>
								<div>
									<IconButton
										color="primary"
										onClick={() => {
											this.restoreSavedSearch(index);
										}}
									>
										<RestorePageIcon />
									</IconButton>

									<IconButton
										onClick={() => {
											this.removeSavedSearch(index);
										}}
									>
										<DeleteIcon />
									</IconButton>
								</div>
							</div>
						);
					})}

					<div className={classes.saveNewSearchSection}>
						<FMPText {...this.setForm('savedName', 'Name of saved search', false)} />

						<Button
							style={{ marginTop: 10 }}
							variant={'outlined'}
							color="primary"
							onClick={() => {
								this.saveSearch();
							}}
						>
							Save Search
						</Button>
					</div>
				</Paper>
			</>
		);
	}

	renderSearch() {
		const { classes } = this.props;
		const { stationFormatErrors } = this.state;

		return (
			<>
				<FMPHeadline label="Station Sales Search and Export" />
				<Paper className={classes.paper}>
					<Grid container spacing={2}>
						{this.renderStationSearchOptions()}
						{this.renderSubmitButtons()}
					</Grid>
				</Paper>

				{!_.isEmpty(stationFormatErrors) && this.renderErrors(stationFormatErrors)}
			</>
		);
	}

	setDateRange = (dateRange) => {
		const { afterDate, beforeDate } = this.dateRangeToDates(dateRange);
		if (!afterDate) {
			this.setState({ dateRange });
		} else {
			this.setState({ dateRange, afterDate, beforeDate });
		}
	};

	dateRangeToDates = (dateRange) => {
		if (dateRange === 'thisMonth') {
			return {
				afterDate: moment().startOf('month').format('YYYY-MM-DD'),
				beforeDate: moment().format('YYYY-MM-DD'),
			};
		} else if (dateRange === 'last2Months') {
			return {
				afterDate: moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
				beforeDate: moment().format('YYYY-MM-DD'),
			};
		} else if (dateRange === 'last4Months') {
			return {
				afterDate: moment().subtract(3, 'month').startOf('month').format('YYYY-MM-DD'),
				beforeDate: moment().format('YYYY-MM-DD'),
			};
		} else {
			return {};
		}
	};

	renderDateButton = (label, range) => {
		const { classes } = this.props;
		const { dateRange } = this.state;

		const variant = dateRange === range ? 'contained' : 'outlined';

		return (
			<Button
				className={classes.dateRange}
				variant={variant}
				color="primary"
				onClick={() => {
					this.setDateRange(range);
				}}
			>
				{label}
			</Button>
		);
	};
	renderDateRangeOptions = () => {
		const { dateRange } = this.state;
		let disabled = true;
		if (dateRange === 'custom') {
			disabled = false;
		}

		return (
			<>
				<Grid item md={12} style={{ display: 'flex' }}>
					{this.renderDateButton('This Month', 'thisMonth')}
					{this.renderDateButton('Last 2 Months', 'last2Months')}
					{this.renderDateButton('Last 4 Months', 'last4Months')}
					{this.renderDateButton('Custom', 'custom')}
				</Grid>
				<FMPDatePicker
					{...this.setForm('afterDate', 'Delivery Date After', true)}
					format={'MMMM Do, YYYY'}
					md={5}
					disabled={disabled}
				/>
				<FMPDatePicker
					{...this.setForm('beforeDate', 'Delivery Date Before', true)}
					format={'MMMM Do, YYYY'}
					md={5}
					disabled={disabled}
				/>
			</>
		);
	};

	renderSubmitButtons = () => {
		const { classes } = this.props;
		const { isSearching } = this.state;

		const params = this.getApiParams();
		params.downloadCsv = true;
		const request = {
			method: 'salesExport.search',
			params,
		};

		let host = '';
		if (isLocalhost) {
			host = 'http://localhost:3700';
		}
		const downloadUrl = `${host}/api?request=${encodeURIComponent(JSON.stringify(request))}`;

		return (
			<Grid container spacing={2}>
				<Grid item md={12} style={{ paddingTop: 25, display: 'flex', paddingBottom: 25 }}>
					<a
						href={downloadUrl}
						style={{ textDecoration: 'none', paddingRight: 5 }}
						target="_blank"
						rel="noreferrer noopener"
					>
						<Button
							className={classes.bigButton}
							variant="contained"
							color="primary"
							style={{ marginLeft: 10 }}
							disabled={isSearching}
						>
							<DownloadIcon className={classes.icon} />
							Search & Download
						</Button>
					</a>

					{isSearching && (
						<div className={classes.runningSearch}>
							<CircularProgress />
							<span style={{ paddingLeft: 5 }}>Searching...</span>
						</div>
					)}
				</Grid>
			</Grid>
		);
	};

	renderStationSearchOptions = () => {
		const { stations, theme } = this.props;

		return (
			<>
				<Grid item xs={12}>
					<FMPSectionHeader label={'Search Params'} isTop={true} />
				</Grid>

				{this.renderDateRangeOptions()}

				<AppBar position="static" color="default" style={{ marginTop: 20 }}>
					<Tabs
						value={this.state.tabIndex}
						onChange={this.handleTabChange}
						indicatorColor="primary"
						textColor="primary"
						variant="fullWidth"
						centered
					>
						<Tab label="Individual Stations" icon={<StationIcon />} />
						<Tab label="Station Filters" icon={<FilterIcon />} />
					</Tabs>
				</AppBar>
				<SwipeableViews
					axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
					index={this.state.tabIndex}
					onChangeIndex={this.handleChangeTabIndex}
					style={{ width: '100%' }}
				>
					<TabContainer dir={theme.direction}>
						<FMPStationMultiSelect
							{...this.setForm('stationIds', 'Station selection', false, [])}
							stations={stations}
						/>
					</TabContainer>
					<TabContainer dir={theme.direction}>
						<Grid container>
							<Grid item xs={12} md={12}>
								<FMPStationRegionPicker {...this.setForm(`region`)} md={12} />
							</Grid>

							<Grid item xs={12} md={12}>
								<FMPStationOwnershipGroupPicker {...this.setForm(`ownershipGroup`)} md={12} />
							</Grid>
						</Grid>
					</TabContainer>
				</SwipeableViews>
			</>
		);
	};
}

SalesExport.propTypes = {
	classes: PropTypes.object.isRequired,
	showErrors: PropTypes.func.isRequired,
	history: PropTypes.object,
	canMakeUpdates: PropTypes.bool,

	stations: PropTypes.array,
	searchStations: PropTypes.func.isRequired,
	stationMap: PropTypes.object,

	accessToken: PropTypes.string,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	StationInvoicesContainer,
	StationsContainer,
	AuthUserContainer,
])(SalesExport);
